export default "__VITE_ASSET__GmnuXSZ0__"